import React, { ComponentProps } from 'react';

import cn from 'classnames';

import { SvgImage } from '../../../../../shared/components';
import { MorePopupOption } from '../../../../../shared/components/more-button-popover/option';
import { ReleasePhase } from '../../../../../types';
import { IndicatorDotColor } from '../../../types';
import styles from './style.css';

type Props = {
    dotColor?: IndicatorDotColor;
    releasePhase?: ReleasePhase | null;
} & ComponentProps<typeof MorePopupOption>;

export function ToolbarOption({ dotColor: dotType, content, releasePhase, ...props }: Props) {
    const classNames = {
        [styles.greenDot]: dotType === 'green',
        [styles.redDot]: dotType === 'red',
    };
    const indicatorDot = dotType && (
        <SvgImage imageName="indicatorDot" className={cn(styles.indicatorDot, classNames)} />
    );

    return (
        <MorePopupOption
            {...props}
            content={
                <div className={styles.toolbarOption}>
                    {content}
                    {releasePhase && (
                        <div className={styles.releasePhaseIconWrapper}>
                            <SvgImage imageName={releasePhase} />
                        </div>
                    )}
                    {indicatorDot}
                </div>
            }
        />
    );
}
